var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campo"},[_c('fai',{staticStyle:{"color":"#0053a2"},attrs:{"icon":['far', 'envelope'],"transform":"shrink-4"}}),(_vm.valor)?_c('span',[_vm._v(_vm._s(_vm.valor))]):_c('CampoVacio',{attrs:{"mensaje":"(sin email)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }